module.exports = __webpack_public_path__ + "static/media/ASC September 2020 Top Five_1599840845167.064a01b1.pptx";